import React, { useState } from "react";
import { Button, Dropdown, Table } from "react-bootstrap";
import { FaFileExport, FaPlus } from "react-icons/fa";
import { HiOutlineHome } from "react-icons/hi";
import AddAgentModal from "../../../components/modals/agent-modals/AddAgentModal";

import { Row, Col, Breadcrumb } from "react-bootstrap";
import { FiDownload, FiChevronUp } from "react-icons/fi";
import { FaRegFileAlt } from "react-icons/fa";
import { RiHome6Line, RiArrowRightSLine } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import AgentsList from "../../../components/super-admin/Subscription/Tickets/AgentsList";
const AgentsPage = () => {
  const [showModal, setShowModal] = useState(false);

  const [agents, setAgents] = useState([
    {
      id: "Agt-016",
      name: "William Parsons",
      email: "william@example.com",
      role: "Senior Support Agent",
      assigned: 30,
      resolved: 20,
      status: "Available",
      img: "/assets/img/agents/agent-01.jpg",
    },
    {
      id: "Agt-015",
      name: "Lucille Tomberlin",
      email: "lucille@example.com",
      role: "Junior Support Agent",
      assigned: 20,
      resolved: 10,
      status: "Available",
      img: "/assets/img/agents/agent-02.jpg",
    },
    {
      id: "Agt-014",
      name: "Frederick Johnson",
      email: "frederick@example.com",
      role: "Senior Support Agent",
      assigned: 10,
      resolved: 8,
      status: "Available",
      img: "/assets/img/agents/agent-03.jpg",
    },
    {
      id: "Agt-013",
      name: "Sarah Henry",
      email: "sarah@example.com",
      role: "Junior Support Agent",
      assigned: 15,
      resolved: 12,
      status: "Available",
      img: "/assets/img/agents/agent-04.jpg",
    },
    {
      id: "Agt-012",
      name: "Thomas Miller",
      email: "thomas@example.com",
      role: "Senior Support Agent",
      assigned: 25,
      resolved: 20,
      status: "Available",
      img: "/assets/img/agents/agent-05.jpg",
    },
    {
      id: "Agt-011",
      name: "Melissa Shelton",
      email: "melissa@example.com",
      role: "Junior Support Agent",
      assigned: 32,
      resolved: 30,
      status: "Available",
      img: "/assets/img/agents/agent-06.jpg",
    },
    {
      id: "Agt-010",
      name: "James Rodriguez",
      email: "james@example.com",
      role: "Senior Support Agent",
      assigned: 12,
      resolved: 10,
      status: "Available",
      img: "/assets/img/agents/agent-07.jpg",
    },
    {
      id: "Agt-009",
      name: "Regina Chavez",
      email: "regina@example.com",
      role: "Junior Support Agent",
      assigned: 8,
      resolved: 5,
      status: "Not Available",
      img: "/assets/img/agents/agent-08.jpg",
    },
  ]);

  const addAgent = (newAgent) => {
    setAgents([...agents, newAgent]);
  };

  return (
    <div style={{ padding: "15px", background: "#f8f9fa",  }}>
      {/* PAGE HEADER */}

      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        <Col md={6} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Agents</h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                    
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Tickets
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Agents</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        <div className="d-flex flex-wrap gap-2">
          {/* EXPORT */}

          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              style={{
                border: "1px solid #e5e7eb",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <FaFileExport /> Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Export as PDF</Dropdown.Item>

              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD AGENT */}

          <Button
            onClick={() => setShowModal(true)}
            style={{
              background: "#f26522",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <FaPlus /> Add New Agent
          </Button>
        </div>
      </div>
      <AgentsList agents={agents} setAgents={setAgents} />

      {/* AGENTS TABLE */}

      {/* <Table bordered responsive>

<thead style={{background:"#f8f9fa"}}>

<tr>

<th>Name</th>

<th>Phone</th>

<th>Email</th>

<th>Department</th>

<th>Designation</th>

</tr>

</thead>

<tbody>

{agents.map(agent=>(
<tr key={agent.id}>

<td>{agent.name}</td>

<td>{agent.phone}</td>

<td>{agent.email}</td>

<td>{agent.department}</td>

<td>{agent.designation}</td>

</tr>
))}

</tbody>

</Table> */}

      {/* MODAL */}

      <AddAgentModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        addAgent={addAgent}
      />
    </div>
  );
};

export default AgentsPage;
